import { NgModule } from '@angular/core';
import { JssModule as JssModuleSitecore } from '@sitecore-jss/sitecore-jss-angular';

@NgModule({
  imports: [JssModuleSitecore],
  exports: [JssModuleSitecore],
})
export class CoreJssProxyModule {}
